import * as React from "react";
import { useState, useContext } from "react";
import Grid from "@mui/material/Unstable_Grid2";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { Formik, Field, Form, ErrorMessage } from "formik";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { Button, TextField, FormHelperText } from "@mui/material";
import Autocomplete, { createFilterOptions } from "@mui/material/Autocomplete";
import RadioGroup from "@mui/material/RadioGroup";
import Radio from "@mui/material/Radio";
import { styled } from "@mui/material/styles";
import { Typography } from "@mui/material";
import ModalSelectCover from "./ModalSelectCover"
import Paper from "@mui/material/Paper";
import useMediaQuery from "@mui/material/useMediaQuery";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  customToastify,
  checkErrorMessage,
  checkResponseData,
} from "../../../utils/utilsFunctions";
import { AutoComplete } from "antd";
import { SuggestedMovies } from "../../../utils/utilsFunctions"
import ProgressBar from "./ProgressBar"
import ClosedCaptionIcon from "@mui/icons-material/ClosedCaption";
// import SelectSubtitles from "./SelectSubtitles";
import { uploadSubtitle } from "../../../../../validations/subtitlesFromValidation";
import { editSubtitlesApi, findSubtitlesWithIdApi } from "../../../../../services/subtitlesApi";
import ErrorIcon from '@mui/icons-material/Error';
import MainContext from "../../../../../context/mainContext";
const SERVER_URL = `${process.env.REACT_APP_SITEURL}`;

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
    padding: 4,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    padding: 10,
    // margin:1
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));
export default function UploadsSubtitles(props) {
  const detectSize600px = useMediaQuery("(min-width:600px)");
  const [userId, setUserId] = React.useState("");
  const [subtitlesId, setSubtitlesId] = React.useState("");
  const [editAccess, setEditAccess] = React.useState(false);
  const [season, setSeason] = React.useState("");
  const [episode, setEpisode] = React.useState("");
  const [subtitlesLanguage, setSubtitlesLanguage] = React.useState("");
  const [modalSelectCover, setModalSelectCover] = useState(false);
  const [coverUrl, setCoverUrl] = useState(false);
  const [nameOfMovie, setNameOfMovie] = useState("");
  const [typeOfVideo, setTypeOfVideo] = useState("");
  const [uploadType, setUploadType] = useState("userUpload");
  const [subtitleUploadPercent, setsubtitleUploadPercent] = useState(0);
  const [autocompleteValue, setAutocompleteValue] = React.useState(null);
  // const [subtitileCode, setSubtitileCode] = React.useState(null);
  const [doneEdit, setDoneEdit] = React.useState(false);
  const {
    userTypes,
  } = useContext(MainContext);

  function CheckUserId() {
    try {
      const token = JSON.parse(localStorage.getItem("token"));
      if (token) {
        const base64Url = token.split(".")[1];
        const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
        const jsonPayload = decodeURIComponent(
          window
            .atob(base64)
            .split("")
            .map(function (c) {
              return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
            })
            .join("")
        );
        const getUserId = JSON.parse(jsonPayload)["id"];
        setUserId(getUserId)
      } else {
        setUserId("");
      }
    } catch {
      setUserId("");
    }
  }


  const searchSubtitle = async (type, data, paginate) => {
    setEditAccess(false)
    setSeason("")
    setEpisode("")
    setSubtitlesLanguage("")
    setModalSelectCover(false)
    setCoverUrl(false)
    setsubtitleUploadPercent(0)
    setNameOfMovie("")
    setTypeOfVideo("")
    setUploadType("")
    setAutocompleteValue("")
    setDoneEdit(false)
    if (subtitlesId.length < 1) customToastify("warning", "لطفا آی دی زیرنویس را وارد کنید");
    else {
      let toastMsg = toast.loading("لطفا صبر کنید...")
      try {
        let response = await findSubtitlesWithIdApi({ subtitlesUploadId: subtitlesId });
        const resData = checkResponseData(response);
        if (resData["success"]) {
          let userAcess = false
          if (userTypes.includes("subtitlesManager") || userTypes.includes("admin") || resData["data"]["data"][0]["userId"] == userId) userAcess = true
          if (!userAcess) {
            toast.update(toastMsg, { render: "این زیرنویس متعلق به شما نمی باشد", type: "error", isLoading: false, autoClose: 3000 });
          } else if (resData["data"]["data"][0]["subtitlesUploadId"]) {
            if (resData["data"]["data"][0]["season"]) {
              setTypeOfVideo("Serial")
              setSeason(resData["data"]["data"][0]["season"])
              setEpisode(resData["data"]["data"][0]["episode"])
            }
            setSubtitlesLanguage(resData["data"]["data"][0]["subtitlesLanguage"])
            setCoverUrl(resData["data"]["data"][0]["coverUrl"])
            setAutocompleteValue(resData["data"]["data"][0]["nameOfMovie"]);
            setNameOfMovie(resData["data"]["data"][0]["nameOfMovie"])
            setUploadType(resData["data"]["data"][0]["type"])
            toast.update(toastMsg, { render: resData["message"] || "درخواست انجام شد", type: "success", isLoading: false, autoClose: 3000 });
            setEditAccess(true)
            // setSubtitileCode(code)
          } else {
            toast.update(toastMsg, { render: resData["message"] || "اتفاق غیر منتظره افتاده است", type: "success", isLoading: false, autoClose: 3000 });
          }
        } else {
          toast.update(toastMsg, { render: resData["message"] || "اتفاق غیر منتظره پیش آمده است", type: "info", isLoading: false, autoClose: 3000 });
        }
      } catch (error) {
        const errData = checkErrorMessage(error);
        let errMsg = errData["titles"] || errData["message"]
        console.log("errData,", errMsg)
        toast.update(toastMsg, { render: errMsg || "مشکلی وجود دارد", type: "error", isLoading: false, autoClose: 3000 });
      }
    }
  }

  const handleModalSelectCover = (coverFile) => {
    if (!autocompleteValue) {
      customToastify("error", "لطفا ابتدا نام فیلم را وارد کنید")
    } else {
      if (coverFile) {
        setCoverUrl(coverFile)
      }
      setModalSelectCover(!modalSelectCover)
    }
  }

  const handleSubtitleUploadPercent = (percent) => {
    setsubtitleUploadPercent(percent * 100)
  }

  const onSubmit = (values, props) => {
    let formData = new FormData();
    // formData.append("subtitles", values.subtitles);
    formData.append("subtitlesUploadId", subtitlesId);
    formData.append("uploadType", uploadType);
    formData.append("subtitlesLanguage", subtitlesLanguage);
    formData.append("nameOfMovie", nameOfMovie);
    formData.append("coverUrl", coverUrl);
    if (typeOfVideo == "Serial") {
      formData.append("season", season);
      formData.append("episode", episode);
    }
    editSubtitlesApiRun(formData)
  };

  const editSubtitlesApiRun = async (formData) => {
    let toastMsg = toast.loading("لطفا صبر کنید...")
    try {
      const data = {};
      const response = await editSubtitlesApi(formData, handleSubtitleUploadPercent);
      const resData = checkResponseData(response);
      if (resData["success"]) {
        let code = resData["data"]["data"][0]["subtitlesUploadId"]
        // customToastify("info",resData["message"] || "اتفاق غیر منتظره پیش آمده است");
        toast.update(toastMsg, { render: resData["message"] || "درخواست انجام شد", type: "success", isLoading: false, autoClose: 3000 });
        setDoneEdit(true)
      } else {
        setsubtitleUploadPercent(101)
        customToastify("info", resData["message"] || "اتفاق غیر منتظره پیش آمده است");
        setDoneEdit(false)
      }
    } catch (error) {
      setsubtitleUploadPercent(101)
      const errData = checkErrorMessage(error);
      let errMsg = errData["titles"] || errData["message"]
      customToastify("info", errMsg || "مشکلی وجود دارد");
      setDoneEdit(false)
      toast.update(toastMsg, { render: errMsg || "مشکلی وجود دارد", type: "error", isLoading: false, autoClose: 5000 });
      console.error(error);
    }
  };



  const resetValueForm = () => {
    setSubtitlesId("")
    setEditAccess(false)
    setSeason("")
    setEpisode("")
    setSubtitlesLanguage("")
    setModalSelectCover(false)
    setCoverUrl(false)
    setsubtitleUploadPercent(0)
    setNameOfMovie("")
    setTypeOfVideo("")
    setUploadType("")
    setAutocompleteValue("")
    setDoneEdit(false)
    // setSubtitileCode(null)
  }

  React.useEffect(() => {
    CheckUserId()
  }, [])
  return (
    <Grid container sx={{ height: "100vh" }}>
      <Box sx={{ width: "100%", px: 1 }}>
        <Paper sx={{ p: 1 }}>
          <Typography sx={{ m: 1 }}>
            به منظور ویرایش زیرنویس ابتدا آی دی زیرنویس را وارد کنید و سپس دکمه بررسی را فشار دهید
          </Typography>
          <TextField value={subtitlesId} size="small" label="آی دی زیرنویس" variant="outlined" onChange={(e) => { setSubtitlesId(e.target.value) }} sx={{ mx: 1 }} />
          <Button variant="contained" onClick={searchSubtitle} >بررسی</Button>
        </Paper >

        {editAccess ?
          <Paper sx={{ textAlign: "center" }}>
            <TableContainer component={Paper}>
              <Table aria-label="customized table">
                <TableHead>
                  <TableRow>
                    <StyledTableCell
                      sx={{ width: detectSize600px ? "25%" : "50%" }}
                    ></StyledTableCell>
                    <StyledTableCell
                      sx={{ width: detectSize600px ? "75%" : "50%" }}
                    >
                      {" "}
                    </StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <StyledTableRow>
                    <StyledTableCell component="th" scope="row">
                      {"نوع فیلم"}
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      <FormControl
                        component="fieldset"
                        sx={{
                          mx: 1,
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                        }}
                      >
                        <RadioGroup
                          onClick={(e) => {
                            // console.log("123", e.target.value);
                            setTypeOfVideo(e.target.value);
                          }}
                          aria-label="videoType"
                          value={typeOfVideo}
                          name={"videoType"}
                          sx={{ display: "flex", flexDirection: "row" }}
                        >
                          <FormControlLabel
                            value="movie"
                            control={<Radio />}
                            label="فیلم"
                          />
                          <FormControlLabel
                            value="Serial"
                            control={<Radio />}
                            label="سریال"
                          />
                          <FormControlLabel
                            value="clip"
                            control={<Radio />}
                            label="کلیپ"
                          />
                        </RadioGroup>
                      </FormControl>
                    </StyledTableCell>
                  </StyledTableRow>

                  <StyledTableRow>
                    <StyledTableCell component="th" scope="row">
                      {"نام فیلم"}
                    </StyledTableCell>

                    <StyledTableCell align="left">
                      <AutoComplete
                        style={{
                          width: 213,
                          margin: 9,
                        }}
                        id="nameOfMovie"
                        value={autocompleteValue}
                        options={(autocompleteValue && autocompleteValue.length >= 2) ? SuggestedMovies : []}
                        disabled={typeOfVideo == ""}
                        placeholder="نام فیلم یا سریال"
                        filterOption={(inputValue, option) =>
                          option.value
                            .toUpperCase()
                            .indexOf(inputValue.toUpperCase()) !== -1
                        }
                        popupClassName="classes.container"
                        onChange={(value) => {
                          setAutocompleteValue(value);
                          setNameOfMovie(value)
                        }}
                      />
                    </StyledTableCell>
                  </StyledTableRow>

                  <StyledTableRow>
                    <StyledTableCell component="th" scope="row">
                      {"زبان زیرنویس"}
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      <FormControl style={{ minWidth: 170 }}>
                        <InputLabel id="demo-simple-select-label">
                          زبان زیرنویس
                        </InputLabel>
                        <Select
                          size="small"
                          label="subtitlesLanguage"
                          name="subtitlesLanguage"
                          id="subtitlesLanguage"
                          value={subtitlesLanguage}
                          onChange={(e) => {
                            setSubtitlesLanguage(e.target.value);
                          }}
                        >
                          <MenuItem key={0} value={"fa"}>
                            Persian
                          </MenuItem>
                          <MenuItem autoFocus key={1} value="en">
                            English
                          </MenuItem>
                          {Object.keys(languagesList).map((option, index) => (
                            <MenuItem key={index + 2} value={option}>
                              {languagesList[option]}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </StyledTableCell>
                  </StyledTableRow>

                  <StyledTableRow>
                    <StyledTableCell component="th" scope="row">
                      {"شماره فصل"}
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      <TextField
                        sx={{ minWidth: 200 }}
                        size="small"
                        type="number"
                        value={season}
                        onChange={(e) => { setSeason(e.target.value) }}
                        InputProps={{ inputProps: { min: 0, max: 50 } }}
                        name="season"
                        disabled={typeOfVideo !== "Serial"}
                        label="فصل"
                        placeholder="فصل"
                      />
                    </StyledTableCell>
                  </StyledTableRow>

                  <StyledTableRow>
                    <StyledTableCell component="th" scope="row">
                      {"شماره قسمت"}
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      <TextField
                        sx={{ minWidth: 200 }}
                        size="small"
                        type="number"
                        disabled={typeOfVideo !== "Serial"}
                        InputProps={{ inputProps: { min: 0, max: 50 } }}
                        name="episode"
                        value={episode}
                        onChange={(e) => { setEpisode(e.target.value) }}
                        label="قسمت"
                        placeholder="قسمت"
                      />
                    </StyledTableCell>
                  </StyledTableRow>

                  <StyledTableRow>
                    <StyledTableCell component="th" scope="row">
                      {"کاور(عکس) فیلم"}
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      <Button onClick={() => { handleModalSelectCover(false) }}>
                        انتخاب کاور
                      </Button>
                      <Typography onClick={() => { navigator.clipboard.writeText(coverUrl) }}>
                        {coverUrl}
                      </Typography>
                      <ModalSelectCover nameOfMovie={nameOfMovie} handleModalSelectCover={handleModalSelectCover} modalSelectCover={modalSelectCover} />
                    </StyledTableCell>
                  </StyledTableRow>

                  {/* <StyledTableRow>
                                  <StyledTableCell component="th" scope="row">
                                    {"انتخاب زیرنویس"}
                                  </StyledTableCell>
                                  <StyledTableCell align="left">
                                    <Button
                                      variant="contained"
                                      component="label"
                                      sx={{ minWidth: "225px", mx: 0.5 }}
                                    >
                                      {subtitleFileName.length > 0
                                        ? subtitleFileName.slice(
                                          subtitleFileName.length - 20 > -1 ? subtitleFileName.length - 20 : 0,
                                          subtitleFileName.length
                                        )
                                        : "انتخاب زیرنویس (SRT)"}
                                      <input
                                        hidden
                                        id="subtitles"
                                        name="subtitles"
                                        type="file"
                                        onChange={(event) => {
                                          if (event.target.files[0]) {
                                            props.setFieldValue(
                                              "subtitles",
                                              event.target.files[0]
                                            );
                                            // console.log("123", event.target.files[0].name);
                                            setSubtitleFileName(event.target.files[0].name);
                                            console.log(subtitleFileName.slice(
                                              subtitleFileName.length - 20 > -1 ? subtitleFileName.length - 20 : 0,
                                              subtitleFileName.length
                                            ))
                                            // handleSubtitleFileName(
                                            //   "one",
                                            //   false,
                                            //   event.target.files[0]
                                            // );
                                          }
                                        }}
                                      />
                                      <ClosedCaptionIcon sx={{ mx: 1 }} />
                                    </Button>
                                    <FormHelperText
                                      sx={{
                                        color: "#f96767",
                                      }}
                                    >
                                      <ErrorMessage name="subtitles" />
                                    </FormHelperText>
                                  </StyledTableCell>
                                </StyledTableRow> */}

                  {userTypes.includes("subtitlesManager") || userTypes.includes("admin") ?
                    <StyledTableRow>
                      <StyledTableCell component="th" scope="row">
                        {"نوع زیرنویس"}
                      </StyledTableCell>
                      <StyledTableCell align="left">
                        <FormControl
                          component="fieldset"
                          sx={{
                            mx: 1,
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                          }}
                        >
                          <RadioGroup
                            onClick={(e) => {
                              setUploadType(e.target.value);
                            }}
                            aria-label="uploadType"
                            value={uploadType}
                            name={"uploadType"}
                            sx={{ display: "flex", flexDirection: "row" }}
                          >
                            <FormControlLabel
                              value="userUpload"
                              control={<Radio />}
                              label="معمولی"
                            />
                            <FormControlLabel
                              value="managerUpload"
                              control={<Radio />}
                              label="متوسط"
                            />
                            <FormControlLabel
                              value="umlang"
                              control={<Radio />}
                              label="ویژه"
                            />

                          </RadioGroup>
                        </FormControl>
                      </StyledTableCell>
                    </StyledTableRow>
                    : null}


                </TableBody>
              </Table>
            </TableContainer>
            <Box
              sx={{ mx: 2, my: 0.5 }}
            >
              {editAccess && !doneEdit ? <Button
                type="submit"
                variant="contained"
                sx={{ mx: 2, my: 0.5, width: "30%" }}
                color="success"
                onClick={onSubmit}
              >
                ویرایش
              </Button> : <Typography>
                ویرایش انجام شد
              </Typography>
              }
              {/* {subtitleUploadPercent == 100 ? <>
                {subtitileCode == null ?
                  <Typography sx={{ color: "green", fontSize: "small" }} >لطفا صبر کنید، در انتظار پاسخ سرور ...</Typography>
                  : <>
                    <Typography sx={{ color: "green", fontSize: "small" }} >آپلود زیرنویس با موفقیت انجام شد</Typography>
                    <Typography
                      onClick={() => {
                        navigator.clipboard.writeText(subtitileCode)
                        // customToastify("info", `آی دی : ${SERVER_URL}/sub/${subtitileCode} کپی شد`)            
                      }}
                      sx={{ fontSize: "small" }}  >کد زیرنویس:{subtitileCode}</Typography>
                    <Button onClick={() => {
                      navigator.clipboard.writeText(`${SERVER_URL}/sub/${subtitileCode}`)
                      customToastify("info", `آی دی : ${SERVER_URL}/sub/${subtitileCode} کپی شد`, 500)
                    }}
                      size="small" sx={{ color: "green" }} >کپی لینک زیرنویس:{`${SERVER_URL}/sub/${subtitileCode}`}</Button>
                    <br />
                    <Button variant="contained" sx={{ m: 0.5 }} onClick={() => { resetValueForm() }} >ویرایش زیرنویس جدید</Button>
                  </>}
              </>
                : null} */}
              {subtitleUploadPercent > 100 ? <>
                <Typography sx={{ color: "red", fontSize: "small" }} >مشکلی وجود دارد</Typography>
                {/* <Button type="submit" variant="contained" sx={{ m: 0.5 }} >تلاش دوباره</Button> */}
                <br />
                <Button variant="contained" sx={{ m: 0.5 }} onClick={() => { resetValueForm() }} >پاک کردن فرم</Button>
              </>
                : null}
            </Box>

          </Paper>
          : null}
      </Box>
    </Grid>
  );
}

const languagesList = {
  ab: "Abkhazian",
  aa: "Afar",
  af: "Afrikaans",
  ak: "Akan",
  sq: "Albanian",
  am: "Amharic",
  ar: "Arabic",
  an: "Aragonese",
  hy: "Armenian",
  as: "Assamese",
  av: "Avaric",
  ae: "Avestan",
  ay: "Aymara",
  az: "Azerbaijani",
  bm: "Bambara",
  ba: "Bashkir",
  eu: "Basque",
  be: "Belarusian",
  bn: "Bengali",
  bh: "Bihari languages",
  bi: "Bislama",
  bs: "Bosnian",
  br: "Breton",
  bg: "Bulgarian",
  my: "Burmese",
  ca: "Catalan, Valencian",
  km: "Central Khmer",
  ch: "Chamorro",
  ce: "Chechen",
  ny: "Chichewa, Chewa, Nyanja",
  zh: "Chinese",
  cu: "Church Slavonic, Old Bulgarian, Old Church Slavonic",
  cv: "Chuvash",
  kw: "Cornish",
  co: "Corsican",
  cr: "Cree",
  hr: "Croatian",
  cs: "Czech",
  da: "Danish",
  dv: "Divehi, Dhivehi, Maldivian",
  nl: "Dutch, Flemish",
  dz: "Dzongkha",
  en: "English",
  eo: "Esperanto",
  et: "Estonian",
  ee: "Ewe",
  fo: "Faroese",
  fj: "Fijian",
  fi: "Finnish",
  fr: "French",
  ff: "Fulah",
  gd: "Gaelic, Scottish Gaelic",
  gl: "Galician",
  lg: "Ganda",
  ka: "Georgian",
  de: "German",
  ki: "Gikuyu, Kikuyu",
  el: "Greek (Modern)",
  kl: "Greenlandic, Kalaallisut",
  gn: "Guarani",
  gu: "Gujarati",
  ht: "Haitian, Haitian Creole",
  ha: "Hausa",
  he: "Hebrew",
  hz: "Herero",
  hi: "Hindi",
  ho: "Hiri Motu",
  hu: "Hungarian",
  is: "Icelandic",
  io: "Ido",
  ig: "Igbo",
  id: "Indonesian",
  ia: "Interlingua (International Auxiliary Language Association)",
  ie: "Interlingue",
  iu: "Inuktitut",
  ik: "Inupiaq",
  ga: "Irish",
  it: "Italian",
  ja: "Japanese",
  jv: "Javanese",
  kn: "Kannada",
  kr: "Kanuri",
  ks: "Kashmiri",
  kk: "Kazakh",
  rw: "Kinyarwanda",
  kv: "Komi",
  kg: "Kongo",
  ko: "Korean",
  kj: "Kwanyama, Kuanyama",
  ku: "Kurdish",
  ky: "Kyrgyz",
  lo: "Lao",
  la: "Latin",
  lv: "Latvian",
  lb: "Letzeburgesch, Luxembourgish",
  li: "Limburgish, Limburgan, Limburger",
  ln: "Lingala",
  lt: "Lithuanian",
  lu: "Luba-Katanga",
  mk: "Macedonian",
  mg: "Malagasy",
  ms: "Malay",
  ml: "Malayalam",
  mt: "Maltese",
  gv: "Manx",
  mi: "Maori",
  mr: "Marathi",
  mh: "Marshallese",
  ro: "Moldovan, Moldavian, Romanian",
  mn: "Mongolian",
  na: "Nauru",
  nv: "Navajo, Navaho",
  nd: "Northern Ndebele",
  ng: "Ndonga",
  ne: "Nepali",
  se: "Northern Sami",
  no: "Norwegian",
  nb: "Norwegian Bokmål",
  nn: "Norwegian Nynorsk",
  ii: "Nuosu, Sichuan Yi",
  oc: "Occitan (post 1500)",
  oj: "Ojibwa",
  or: "Oriya",
  om: "Oromo",
  os: "Ossetian, Ossetic",
  pi: "Pali",
  pa: "Panjabi, Punjabi",
  ps: "Pashto, Pushto",
  fa: "Persian",
  pl: "Polish",
  pt: "Portuguese",
  qu: "Quechua",
  rm: "Romansh",
  rn: "Rundi",
  ru: "Russian",
  sm: "Samoan",
  sg: "Sango",
  sa: "Sanskrit",
  sc: "Sardinian",
  sr: "Serbian",
  sn: "Shona",
  sd: "Sindhi",
  si: "Sinhala, Sinhalese",
  sk: "Slovak",
  sl: "Slovenian",
  so: "Somali",
  st: "Sotho, Southern",
  nr: "South Ndebele",
  es: "Spanish, Castilian",
  su: "Sundanese",
  sw: "Swahili",
  ss: "Swati",
  sv: "Swedish",
  tl: "Tagalog",
  ty: "Tahitian",
  tg: "Tajik",
  ta: "Tamil",
  tt: "Tatar",
  te: "Telugu",
  th: "Thai",
  bo: "Tibetan",
  ti: "Tigrinya",
  to: "Tonga (Tonga Islands)",
  ts: "Tsonga",
  tn: "Tswana",
  tr: "Turkish",
  tk: "Turkmen",
  tw: "Twi",
  ug: "Uighur, Uyghur",
  uk: "Ukrainian",
  ur: "Urdu",
  uz: "Uzbek",
  ve: "Venda",
  vi: "Vietnamese",
  vo: "Volap_k",
  wa: "Walloon",
  cy: "Welsh",
  fy: "Western Frisian",
  wo: "Wolof",
  xh: "Xhosa",
  yi: "Yiddish",
  yo: "Yoruba",
  za: "Zhuang, Chuang",
  zu: "Zulu",
};
